import { FC, useMemo } from "react";
import { DefaultButton, IButtonStyles, IconButton, mergeStyleSets, Text } from "@fluentui/react";
import { themeUtils, useTheme } from "cayo.ui";
import styled from "styled-components";
import { FilterItem } from "@cayo/shared/components/GridContainer/types";

type FilterItemButtonProps = FilterItem & { onClick: () => void };

export const FilterItemButton: FC<FilterItemButtonProps> = ({
  displayValue,
  name,
  label,
  onClick,
}) => {
  const { officeTheme } = useTheme();

  const filterButtonStyle = useMemo(() => {
    return mergeStyleSets({
      root: {
        borderRadius: "18px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: "2px 0px 2px 8px",
        position: "relative",
        height: 28,
        backgroundColor: themeUtils.addAlpha(
          officeTheme.semanticColors.primaryButtonBackground,
          0.2
        ),
      },
      rootHovered: {
        backgroundColor: themeUtils.addAlpha(
          officeTheme.semanticColors.primaryButtonBackgroundHovered,
          0.5
        ),
      },
    } as IButtonStyles);
  }, []);

  return (
    <DefaultButton key={name} styles={filterButtonStyle}>
      <Text variant="small">{label}&nbsp;</Text>
      <Text variant="small" styles={{ root: { fontWeight: "bold" } }}>
        {displayValue}
      </Text>
      <StyledIconButton
        onClick={onClick}
        iconProps={{
          iconName: "Clear",
          styles: { root: { fontSize: 12, color: officeTheme.semanticColors.inputText } },
        }}
        styles={{
          rootHovered: { backgroundColor: officeTheme.semanticColors.bodyStandoutBackground },
          root: { height: 24, width: 24, margin: "0 1px 0 4px" },
        }}
      />
    </DefaultButton>
  );
};

const StyledIconButton = styled(IconButton)`
  border-radius: 50%;
  z-index: 1;
`;
